import { render } from "./DietResults.vue?vue&type=template&id=d5086344"
import script from "./DietResults.vue?vue&type=script&lang=js"
export * from "./DietResults.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__